import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import NvIcon from 'shared/components/nv-icon';

import { TimelineSurvey } from 'redux/schemas/models/survey';

import { CheckIcon, todoIcon, todoProgress } from './todo-row';

type SurveyTodoProps = TimelineSurvey & {
  thumbnailSrc: string,
  backgroundColor: string,
};

function SurveyTodo({
  type,
  title,
  progress,
  expirationDate,
  thumbnailSrc,
  backgroundColor,
}: SurveyTodoProps) {
  const icon = todoIcon[type];
  const deadlineMoment = moment(expirationDate);
  const deadlineDay = deadlineMoment.format('dddd');
  const deadlineTime = deadlineMoment.format('lll');
  const currentMoment = moment();

  const isMissed = progress === todoProgress.MISSED;
  const isComplete = progress === todoProgress.COMPLETED;

  const showDueSoon = !isComplete
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <div className='todo-cover'>
          {thumbnailSrc
            ? <img src={thumbnailSrc} alt='' />
            : <div className='square-thumbnail' style={{ backgroundColor }} />}
        </div>
        <div className='todo-icon'>
          {isComplete
            ? <CheckIcon />
            : <NvIcon icon={icon} size='smallest' />}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
        </div>
        {expirationDate && (
          <div className='date'>
            <span className='day'>{deadlineDay}</span>
            <span className='time'>{deadlineTime}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SurveyTodo;
